import { render } from "./offerpage.vue?vue&type=template&id=7be563c4"
import script from "./offerpage.vue?vue&type=script&lang=js"
export * from "./offerpage.vue?vue&type=script&lang=js"

import exportComponent from "/home/julien/build/build/p2p-exchange/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__